import PDPHeader from './PDPHeader';
import { PDP_HEADER_TAB_LABEL } from './constants/index';

export { PDP_HEADER_TAB_LABEL };
export default PDPHeader;
